import { toUpper as _toUpper, snakeCase as _snakeCase } from 'lodash';

export default function buildSdkParamsFromProperties({
  properties,
  required = [],
  existingParams = [],
  integrationData = {},
  vars,
}) {
  if (!properties) {
    return [];
  }
  return Object.keys(properties).map(property => {
    const paramName = _toUpper(_snakeCase(property));
    const existingParam = existingParams.find(p => p.name === paramName);
    const oldStyleParam = existingParams.find(p => p.name === property);
    const rawIntegrationValue = integrationData[property];
    // Skip placeholder values like $$PARAM_NAME$$ - they're not actual values
    const isPlaceholder = typeof rawIntegrationValue === 'string' && /^\$\$.+\$\$$/.test(rawIntegrationValue);
    const integrationValue = isPlaceholder ? undefined : rawIntegrationValue;
    const varsValue = vars?.[property];
    const isOptional = !required.includes(property);

    return {
      name: paramName,
      isOptional,
      ...(oldStyleParam?.pipelineVarId && { pipelineVarId: oldStyleParam.pipelineVarId }),
      ...(varsValue !== undefined && { defaultValue: String(varsValue) }),
      ...(existingParam?.pipelineVarId && { pipelineVarId: existingParam.pipelineVarId }),
      ...(existingParam?.defaultValue !== undefined && { defaultValue: existingParam.defaultValue }),
      ...(existingParam?.opId && { opId: existingParam.opId }),
      ...(existingParam?.opIndex && { opIndex: existingParam.opIndex }),
      ...(integrationValue !== undefined && { defaultValue: integrationValue }),
    };
  });
}
